"use client";

import { Box, Flex } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { useThemeTokens } from "@/lib/theme/tokens";

export function PublicListingToolbar({ children }: { children: ReactNode }) {
  const theme = useThemeTokens();

  return (
    <Box
      position="sticky"
      top={{ base: "100px", md: "104px" }}
      zIndex={2}
      py={{ base: 2, md: 3 }}
      borderBottomWidth="1px"
      borderColor={theme.borderGlass.subtle}
      sx={{
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <Flex
        gap="10px"
        wrap="wrap"
        justifyContent="space-between"
        direction={{ base: "column", md: "row" }}
        alignItems={{ base: "stretch", md: "flex-start" }}
      >
        {children}
      </Flex>
    </Box>
  );
}
